"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FilterManager = /*#__PURE__*/function () {
  /**
   * Handles filters
   * @constructor
   */
  function FilterManager() {
    _classCallCheck(this, FilterManager);

    /**
     * Dictionary of filter IDs.
     * @type {Object.<string, boolean>}
     */
    this.filterIds = {};
    /**
     * List of all the Filters and Filter IDs provided by the system.
     * @type {Object}
     */

    this.categoryMappings = {};
    /**
     * The filtering mode.
     *
     * EXCLUSIVE - Content Items must match all selected filter elements in order to be displayed.
     * INCLUSIVE (default) - Content Items must be tagged with at least one of the selected filter elements within a given filter.     *
     *
     * E.g. user selects 4 filter elements from 2 different filters
     * Exclusive => items must match Filter1-element1 AND Filter1-element2 AND Filter2-element1 AND Filter2-element2
     * Inclusive => items must match (Filter1-element1 OR  Filter1-element2) AND (Filter2-element1 OR Filter2-element2)
     *
     * @type {string}
     */

    this.filterMode = FilterManager.FILTER_MANAGER_MODE_INCLUSIVE;
    /**
     * @type {string}
     * @private
     */

    this.freeTextSearch = '';
  }
  /**
   * static class constant to set filterMode to EXCLUSIVE
   *
   * @returns {string}
   */


  _createClass(FilterManager, [{
    key: "updateFilter",

    /**
     * Adds or removes the passed FilterElement from the current set of filters. Adds the FilterElement if it has selected=true. Removes the FilterElement if it has selected=false.
     * @param {FilterElement} filterElement
     */
    value: function updateFilter(filterElement) {
      if (filterElement.selected) {
        this.filterIds[filterElement.id] = true;
      } else {
        delete this.filterIds[filterElement.id];
      }
    }
    /**
     * Filters the content based on free text search. Only descriptive properties are searched. Content is not.
     * @param {string} textSearch
     */

  }, {
    key: "updateFreeTextSearch",
    value: function updateFreeTextSearch(textSearch) {
      this.freeTextSearch = textSearch;
    }
    /**
     * Checks the passed content types against the current set of filters. Returns the ones that have elements that matches the current filters.
     * @param {ContentType[]} contentTypes
     * @return {ContentType[]}
     */

  }, {
    key: "parseContentTypes",
    value: function parseContentTypes(contentTypes) {
      var filteredContentTypes = Object.keys(this.filterIds).length === 0 ? contentTypes.filter(function (contentType) {
        contentType.filteredItems = contentType.items.map(function (item) {
          return item;
        });
        return true;
      }) : this.filterByMethod(contentTypes, this.filterMode);

      if (this.freeTextSearch === '') {
        return filteredContentTypes;
      }

      var searchTerm = this.freeTextSearch.toLocaleLowerCase();
      return contentTypes.filter(function (contentType) {
        contentType.filteredItems = contentType.filteredItems.filter(function (filteredItem) {
          return filteredItem.name.toLowerCase().indexOf(searchTerm) !== -1;
        });
        return contentType.filteredItems.length > 0;
      });
    }
    /**
     * filters the contentTypes according to which method was selected. Returns the ones that have elements that matches the current filters.
     * @param {ContentType[]} contentTypes
     * @param {String} method
     * @returns {ContentType[]}
     */

  }, {
    key: "filterByMethod",
    value: function filterByMethod(contentTypes, method) {
      var _this = this;

      if (method === FilterManager.FILTER_MANAGER_MODE_INCLUSIVE) {
        // Reduce our category mappings to only those filters that have been selected.
        var filteredCategoryMappings = this.categoryMappings.filter(function (myFilter) {
          myFilter.filteredElements = myFilter.elements.filter(function (filterElement) {
            var isSelected = false;
            Object.keys(_this.filterIds).forEach(function (filterId) {
              if (filterElement.id === filterId) {
                isSelected = true;
              }
            });
            return isSelected;
          });
          return myFilter.filteredElements.length > 0;
        }); // Filter our content items based on which filters were selected.

        return contentTypes.filter(function (contentType) {
          var tempItems = contentType.items.length > 0 ? contentType.items : [];
          var tempFilteredItems = [];
          filteredCategoryMappings.forEach(function (categoryFilters) {
            tempItems.forEach(function (item) {
              categoryFilters.filteredElements.forEach(function (filterElement) {
                if (item.filters.indexOf(filterElement.id) > -1) {
                  // check if item already in array, if not add it in.  Prevents duplicate items from entering contentItems
                  if (tempFilteredItems.findIndex(function (e) {
                    return e.id === item.id;
                  }) === -1) {
                    tempFilteredItems.push(item);
                  }
                }
              });
            });
            tempItems = tempFilteredItems;
            tempFilteredItems = [];
          });
          contentType.filteredItems = tempItems;
          return contentType.filteredItems.length > 0;
        });
      } // EXCLUSIVE Mode - DEFAULT


      return contentTypes.filter(function (contentType) {
        contentType.filteredItems = contentType.items.filter(function (item) {
          var matchesFilters = true;
          Object.keys(_this.filterIds).forEach(function (filterId) {
            if (item.filters.indexOf(filterId) === -1) {
              matchesFilters = false;
            }
          });
          return matchesFilters;
        });
        return contentType.filteredItems.length > 0;
      });
    }
    /**
     * Updates the passed filters and sets the ones that matches the current set of filters to selected.
     * @param {Filter[]} filters
     * @returns {Filter[]}
     */

  }, {
    key: "parseFilters",
    value: function parseFilters(filters) {
      var _this2 = this;

      return filters.map(function (filter) {
        filter.elements = filter.elements.map(function (filterElement) {
          filterElement.selected = filterElement.id in _this2.filterIds;
          return filterElement;
        });
        return filter;
      });
    }
  }, {
    key: "clearFilters",
    value: function clearFilters() {
      this.filterIds = {};
    }
  }], [{
    key: "FILTER_MANAGER_MODE_EXCLUSIVE",
    get: function get() {
      return 'exclusive';
    }
    /**
     * static class constant to set filterMode to INCLUSIVE
     * @returns {string}
     */

  }, {
    key: "FILTER_MANAGER_MODE_INCLUSIVE",
    get: function get() {
      return 'inclusive';
    }
  }]);

  return FilterManager;
}();

var _default = FilterManager;
exports["default"] = _default;